import { useEffect, useState } from 'react';
import useEcho from './useEcho';
import { TICKETS_API } from '../views/MainLayout/components/shared/services/tickets';

export default function useTicketListener(userId) {
    const [ticketCount, setTicketCount] = useState(0);
    const echo = useEcho();

    useEffect(() => {
        TICKETS_API.getCount()
            .then((resp) => setTicketCount(resp.data))
            .catch(console.error);

        if (!echo || !userId) return;

        const channel = echo.private(`tickets.user.${userId}`);

        const onIncrement = () => setTicketCount((prev) => prev + 1);
        channel.listen('TicketIncremented', onIncrement);

        const onDecrement = () => setTicketCount(prev => Math.max(prev - 1, 0));
        channel.listen("TicketDecremented", onDecrement);

        return () => {
          channel.stopListening("TicketIncremented", onIncrement);
          channel.stopListening("TicketDecremented", onDecrement);
        };
    }, [echo]);

    return ticketCount;
}
